import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import './Spinner.css';

const LoadingSpinner = (props) => {
    const padding = props.padding || "0px";
    const type = props.type || "ball-pulse-rise";
    const backgroundText = props.backgroundText

    return (
        <div className="spinnerContainer">
            <div className="fullHeight flexCenterAlign">
                <div className="spinnerBackground">
                    <Spinner animation="border" variant="primary" />
                    <p>{backgroundText}</p>
                </div>
            </div>
        </div>
    );
}

export default LoadingSpinner;